/**
 * テキストの省略処理を行う際のサイズ
 */
type LineClampSize = 'XS' | 'S' | 'M' | 'L';

export const lineClampSizes: Record<LineClampSize, number> = {
  XS: 10,
  S: 20,
  M: 50,
  L: 100,
};
